import React from "react";
import AppError from "../../errors/AppError";
import { logErrorToLogdna } from "../../helpers/logdna";

type PropsType = {
  children: React.ReactNode;
};

class AppErrorBoundary extends React.Component<PropsType> {
  componentDidCatch(error: Error) {
    // Log full error server-side only
    logErrorToLogdna("APP_ERROR_BOUNDARY", error.message, error);

    if (error.message.includes("Loading chunk")) {
      throw new AppError("Network error", "Please reload the page.");
    } else {
      // Don't expose stack traces to client
      console.error(
        "An error occurred. Please contact support if this persists."
      );
      throw new AppError(
        "Application error",
        "Something went wrong. Please try again."
      );
    }
  }

  render() {
    return this.props.children;
  }
}

export default AppErrorBoundary;
